<template>
  <section class="hero-section site-hero">
    <HeroLinks />

    <div class="hero-text">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="site-hero-content">
          <div class="mb-4">
            <h1 class="page-title">{{ pageTitle }}</h1>
          </div>
          <p v-if="pageDescription" class="hero-text">{{ pageDescription }}</p>
        </div>
      </div>
    </div>
  </section>
  <BorderHeroBottom />
</template>

<script>
  import BorderHeroBottom from './BorderHeroBottom.vue'
  import HeroLinks from './HeroLinks.vue';
  import './hero.css';

  export default {
    name: 'SiteHero',
    components: {
      BorderHeroBottom,
      HeroLinks,
    },
    props: {
      pageTitle: {
        type: String,
        required: true,
      },
      pageDescription: {
        type: String,
        required: false,
        default: '',
      },
    },
  };
</script>

<style scoped>
  .site-hero {
    background-image: url('@/assets/images/page-bg.png');
    min-height: 45vh;
  }

  .site-hero-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>